<template>
    <v-snackbar
        v-for="(error, i) in alertErrors"
        :key="i"
        :model-value="true"
        color="error"
        :timeout="-1"
    >
        {{ error }}
        <template v-slot:action>
            <v-btn variant="text" @click="closeError(i)"> Close </v-btn>
        </template>
    </v-snackbar>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

const store = useStore()
const route = useRoute()

const alertErrors = computed(() => store.state.alertErrors)
const initialRoute = route.path

function closeError(index) {
    const remainingErrors = alertErrors.value.filter((_error, i) => i !== index)
    store.commit('SET_ALERT_ERRORS', remainingErrors)
}

watch(route, (newRoute) => {
    if (newRoute.path !== initialRoute) {
        store.commit('SET_ALERT_ERRORS', [])
    }
})
</script>
